/**
 * 流式显示平滑总开关（打字机逐字渲染 + 过程面板帧节流）。
 *
 * 默认【关闭】：正文与过程面板按上游 SSE 到达的节奏即时渲染，不做逐字平滑/去抖，
 * 便于"原速"观察上游输出（不再有"看起来一坨"的显示层节流）。
 *
 * 运行时临时开启（无需重新构建）：
 *   localStorage.setItem("opsmate.streamSmoothing", "1")
 * 关闭：
 *   localStorage.removeItem("opsmate.streamSmoothing")
 */
export function isStreamSmoothingEnabled(): boolean {
  try {
    return localStorage.getItem("opsmate.streamSmoothing") === "1";
  } catch {
    return false;
  }
}
